export const Prices = [
    {
        _id: 0,
        name: "₹0 to ₹199",
        array: [0, 199],
    },
    {
        _id: 1,
        name: "₹200 to ₹499",
        array: [200, 499],
    },
    {
        _id: 2,
        name: "₹500 to ₹999",
        array: [500, 999],
    },
    {
        _id: 3,
        name: "₹1000 to ₹10000",
        array: [1000, 10000],
    },
    {
        _id: 4,
        name: "₹10000 or more",
        array: [10000, 99999],
    },
];
